// AUTO-GENERATED by tools/generate-world2.mjs. Do not edit by hand.
// Regenerate with: node tools/generate-world2.mjs
import type { LevelDef } from '@tessera/engine';

export const WORLD_2_GENERATED: LevelDef[] = [
  // d*=3  branching=11.29  D=0.051
  {
    id: 'w2-l01',
    world: 2,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: 2, r: -2 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    ],
  },
  // d*=4  branching=12.60  D=0.113
  {
    id: 'w2-l02',
    world: 2,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: 2, r: 0 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 1 }, color: 0 },
    { coord: { q: -1, r: -1 }, color: 0 },
    ],
  },
  // d*=4  branching=14.62  D=0.133
  {
    id: 'w2-l03',
    world: 2,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: 0, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: 2, r: -1 }, color: 1 },
    { coord: { q: -2, r: 1 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1 },
    ],
  },
  // d*=4  branching=17.04  D=0.156
  {
    id: 'w2-l04',
    world: 2,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -1 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: -1, r: 0 }, color: 1 },
    { coord: { q: 0, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    ],
  },
  // d*=4  branching=24.44  D=0.327
  {
    id: 'w2-l05',
    world: 2,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: 0, r: 2 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 1, r: 0 }, color: 0 },
    { coord: { q: 1, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 1 }, color: 1 },
    { coord: { q: 2, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 2 }, color: 0 },
    ],
  },
  // d*=4  branching=24.77  D=0.329
  {
    id: 'w2-l06',
    world: 2,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: -1, r: 2 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: -2, r: 2 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -2, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    ],
  },
  // d*=5  branching=14.31  D=0.180
  {
    id: 'w2-l07',
    world: 2,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: 1, r: 1 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: -1, r: -1 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 2 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    ],
  },
  // d*=5  branching=19.37  D=0.229
  {
    id: 'w2-l08',
    world: 2,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: -1, r: 0 }, color: 0 },
    { coord: { q: -1, r: -1 }, color: 1 },
    { coord: { q: 0, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 2, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    ],
  },
  // d*=5  branching=22.77  D=0.261
  {
    id: 'w2-l09',
    world: 2,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: 2, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 2 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 1 },
    ],
  },
  // d*=5  branching=23.63  D=0.370
  {
    id: 'w2-l10',
    world: 2,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: -1, r: -1 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 2 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 0 }, color: 0 },
    { coord: { q: 1, r: 0 }, color: 1 },
    ],
  },
];
